/**
 * Auth Layout Component
 * Wrapper layout for authentication pages
 */

import { ReactNode } from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  showLogo?: boolean;
}

export function AuthLayout({
  children,
  title,
  subtitle,
  showLogo = true,
}: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4 dark:from-gray-950 dark:to-gray-900 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        {showLogo && (
          <div className="text-center">
            <div className="flex justify-center">
              <div className="rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-700 p-3 shadow-lg shadow-indigo-500/30 dark:shadow-none">
                <CheckIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">Chores Champ</h1>
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">Task management made simple</p>
          </div>
        )}

        <div className="mt-8 rounded-2xl border border-gray-200 bg-white px-6 py-8 shadow-xl dark:border-gray-800 dark:bg-gray-900 dark:shadow-none sm:px-10">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
          {subtitle && <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">{subtitle}</p>}

          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
